import { createFileRoute } from "@tanstack/react-router";
import { CertificacaoLP } from "@/components/certificacao/CertificacaoLP";
import { CERT_QUADRIL_GRUPO } from "@/lib/certificacao/data";

/** Backup interno da LP da Quadril na fase de grupo. Referência para lançamentos com grupo. */
export const Route = createFileRoute("/certificacao-quadril-grupo")({
  head: () => ({
    meta: [
      { title: "Backup · Certificação em Quadril (fase grupo) | FEO" },
      { name: "description", content: "Referência interna da página de pré-matrícula com grupo de WhatsApp da Certificação em Quadril." },
      { name: "robots", content: "noindex,nofollow" },
      { property: "og:title", content: "Backup · Certificação em Quadril (fase grupo)" },
      { property: "og:description", content: "Referência interna da fase de grupo do lançamento da Certificação em Quadril." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: () => <CertificacaoLP slug="quadril" mode="captura" data={CERT_QUADRIL_GRUPO} />,
});
